export const SOCKET_KEYS = {
  WORKSPACE: "workspaces",
  NOTIFICATION: "notification",
  XERO_CONNECTION_STATUS: "xero-connection-status",
  ROSTER_DAY_SHEET: "roster_day_sheet",
  ROSTER_FLEETS: "roster_fleets",
  PROJECT_REGISTER: "project-register",
  PROJECT_REGISTER_DRIVE: "project-register-drive",
  ESTIMATES: "estimates",
  PROJECTS: "projects",
  PROJECTS_DRIVE: "projects-drive",
  TASK_CLAIMS: "task-claims",
  TASK_CLAIMS_DRIVE: "task-claims-drive",
  WORKFORCE_ADMIN: "workforce-admin",
  WORKFORCE_MANAGER: "workforce-manager",
  WORKFORCE_EMPLOYEE: "workforce-employee",
  WORKFORCE_SUBCONTRACTOR: "workforce-subcontractor",
  WORKFORCE_SETTING: "workforce-setting",
  CLIENTS_CUSTOMER: "clients-customer",
  CLIENTS_PROSPECT: "clients-prospect",
  CLIENTS_CUSTOMER_USER: "clients-customer-user",
  CLIENTS_PROSPECT_USER: "clients-prospect-user",
  INVOICE_DOCKET: "invoice-docket",
  INVOICE_XERO: "invoice-xero",
  INVOICE_CONTRACT: "invoice-contract",
  INVOICE_XERO_BILL: "invoice-xero-bill",
  INVOICE_XERO_CONTACT: "invoice-xero-contact",
  WASTE_MANAGEMENT_SUMMARY: "waste-management-summary",
  WASTE_MANAGEMENT_WEIGH_SCALE: "waste-management-weigh-scale",
  WASTE_MANAGEMENT_WEIGH_BRIDGE: "waste-management-weigh-bridge",
  // WASTE_MANAGEMENT_WEIGH_REPORTS: 'waste-management-weigh-reports',
  WASTE_MANAGEMENT_VEHICLES: "waste-management-vehicles",
  WASTE_MANAGEMENT_LOAD_TYPE: "waste-management-load-type",
  WASTE_MANAGEMENT_WASTE_TYPE: "waste-management-waste-type",
  WASTE_MANAGEMENT_DAILY_REPORTS: "waste-management-daily-reports",
  WASTE_MANAGEMENT_SETTINGS_DOCUMENT: "waste-management-settings-document",
  WASTE_MANAGEMENT_SETTINGS_FORMAT: "waste-management-settings-format",
  REPORTS_DAILY_REPORT: "reports-daily-report",
  REPORTS_WORK_DOCKET: "reports-work-docket",
  TIME_TRACKING_SUMMARY: "time-tracking-summary",
  TIME_TRACKING_EMPLOYEE: "time-tracking-employee",
  TIME_TRACKING_SUBCONTRACTOR: "time-tracking-subcontractor",
  TIME_TRACKING_SETTINGS: "time-tracking-settings",
  TIME_TRACKING_HOLIDAYS: "time-tracking-holidays",
  TIME_TRACKING_SHIFTS: "time-tracking-shifts",
  TIME_TRACKING_BREAKS: "time-tracking-breaks",
  PAYROLL_PART1: "payroll-part1",
  PAYROLL_PART2: "payroll-part2",
  ITEM: "item",
  XERO_ITEM: "xero-item",
  ITEM_RATE: "item-rate",
  ITEM_GROUP: "item-group",
  FLEET_REGISTER: "fleet-register",
  INTELLIFLOW_EXTRACTED: "intelliflow-extracted",
  INTELLIFLOW_UPLOADED: "intelliflow-uploaded",
  INTELLIFLOW_EXISTS: "intelliflow-exists",
  WAREHOUSE_BASE: "warehouse-base",
  WAREHOUSE_ITEMS: "warehouse-items",
  WAREHOUSE_PROJECTS: "warehouse-projects",
  WAREHOUSE_HISTORY: "warehouse-history",
  SUPPORT_TEAM: "support-team",
  SUPPORT_TICKET: "support-ticket",
  SUPPORT_DOCUMENT: "support-document",
  SUPPORT_COMMENT: "support-comment",
  CALENDAR: "calendar",
  MESSAGE: "message",
  CHAT_GROUP: "chat-group",
} as const;

export const ADMIN_PORTAL = "admin-portal";

export const SOCKET_EVENT = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
};

export type SocketEventType = (typeof SOCKET_EVENT)[keyof typeof SOCKET_EVENT];

export const CLAIM_TABS = {
  APPROVED: "approved",
  DRAFTS: "draft",
};
